import React, { useState, useMemo } from "react";
import { Pagination } from "antd";
import {
  CustomLabel,
} from "../../../../../Common/style";
import DiagnosticCenterCard from "../../../../../Components/DiagnosticCenterCard";
import PAGE_CONSTANTS from "../../constant";
import "./centerList.css";

const CenterListTemplate = ({ dcList, onBookAppointmentClick, type }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const onChangePage = (page) => {
    setCurrentPage(page);
  };
  // Function to get total pages
  const getTotalPages = (array, itemsPerPage) => {
    return Math.ceil(array.length / itemsPerPage);
  };

  // Function to paginate array
  const paginate = (array, itemsPerPage, page) => {
    const totalPages = getTotalPages(array, itemsPerPage);
    if (page < 1 || page > totalPages) {
      console.log("Invalid page number");
      return;
    }
    const start = (page - 1) * itemsPerPage;
    const end = start + itemsPerPage;
    return array.slice(start, end);
  };
  const paginatedItems = useMemo(
    () => paginate(dcList, 10, currentPage),
    [currentPage]
  );
  const getNotFoundText = () => {
    return (
      <CustomLabel font_size="16" font_weight="bold" style={{marginTop: "24px"}}>
      {`Service unavailable for this location. Please try with another pincode`}
    </CustomLabel>
    )
  }
  const getCenterListContent = () => {
    return (<>
       {type === PAGE_CONSTANTS?.HOME_VISIT_TYPE && <CustomLabel className="match-found" font_size="12" font_weight="normal">
        {`Note : Representative will visit from the below diagnostic center.`}
      </CustomLabel>}
      <CustomLabel className={type === PAGE_CONSTANTS?.HOME_VISIT_TYPE ? "note-home" : "match-found"} font_size="12" font_weight="normal">
        {`${dcList?.length} matches found`}
      </CustomLabel>
      {paginatedItems?.map((clinic, index) => (
        <DiagnosticCenterCard
          key={index}
          {...clinic}
          btnText={type === PAGE_CONSTANTS?.HOME_VISIT_TYPE ? "Select Center" : "Book Appointment"}
          onBookAppointmentClick={() => onBookAppointmentClick(clinic)}
        />
      ))}
      <div className="dc-pagination justify-flex-end">
        <Pagination
          size={"small"}
          current={currentPage}
          defaultPageSize={10}
          onChange={onChangePage}
          total={dcList?.length}
        />
      </div>
    </>)
  }
  return (dcList?.length > 0) ? getCenterListContent() : getNotFoundText();
};

export default CenterListTemplate;
